import { BaseEditor, type BaseEditorProps } from './BaseEditor';

import type { JSONContent } from './components';
import type { EditorEvents } from '@tiptap/core';

interface EditorProps extends Omit<BaseEditorProps<JSONContent>, 'onUpdate'> {
  /** Initial JSON content to display in the editor */
  initialContent?: JSONContent;
  /** Callback fired when editor content changes, receives JSON content object */
  onUpdate?: (json: JSONContent) => void;
}

export const Editor = ({ onUpdate, ...props }: EditorProps) => {
  const update = ({ editor }: EditorEvents['update']) =>
    onUpdate?.(editor.getJSON());

  return <BaseEditor<JSONContent> {...props} onUpdate={update} />;
};
